import { __ } from '@wordpress/i18n';
import {
    Popover,  __experimentalHStack as HStack, __experimentalVStack as VStack,
    __experimentalText as Text, Button, __experimentalToolsPanelItem as ToolsPanelItem,
    __experimentalToggleGroupControl as ToggleGroupControl, 
    __experimentalToggleGroupControlOption as ToggleGroupControlOption,
    RangeControl,
} from '@wordpress/components';

const animationOptions = [
    { value: 'none', label: __('None', 'vayu-blocks'), className: 'vayu-blocks-none-button' },
    { value: 'rotate-image', label: __('Rotate Image', 'vayu-blocks') },
    { value: 'clip-animation', label: __('Clip Animation', 'vayu-blocks') },
    { value: 'clip-diagonal-expand', label: __('Clip Diagonal Expand', 'vayu-blocks') },
    { value: 'clip-starburst', label: __('Clip Starburst', 'vayu-blocks') },
    { value: 'clip-diamond', label: __('Clip Diamond', 'vayu-blocks') },
    { value: 'clip-diagonal-slide', label: __('Clip Diagonal Slide', 'vayu-blocks') },
    { value: 'clip-hex-pulse', label: __('Clip Hex Pulse', 'vayu-blocks') },
    { value: 'clip-triangle-expand', label: __('Clip Triangle Expand', 'vayu-blocks') },
    { value: 'clip-circle-burst', label: __('Clip Circle Burst', 'vayu-blocks') },
    { value: 'clip-zigzag', label: __('Clip Zigzag', 'vayu-blocks') },
    { value: 'clip-diamond-expand', label: __('Clip Diamond Expand', 'vayu-blocks') },
    { value: 'shake', label: __('Shake', 'vayu-blocks') },
];

export const ImageAnimation = ({
    imagePopoverAnchor,
    setisImageVisible,
    animationData,
    dataKey, 
    onChange
}) => {
    const handleImagehoverClick = (animation) => {
        const updatedAnimationData = {
            ...animationData,
            imageAnimation: {
                ...animationData.imageAnimation,
                hover: animation,
            },
        };
    
        onChange(dataKey, updatedAnimationData);
    };
    
    const handleImageAnimationClick = (animation) => {
        const updatedAnimationData = {
            ...animationData,
            imageAnimation: {
                ...animationData.imageAnimation,
                animationValue: animation,
            },
        };
    
        onChange(dataKey, updatedAnimationData);
    };

    const handlespeed = (value) => {
        const updatedAnimationData = {
            ...animationData,
            imageAnimation: {
                ...animationData.imageAnimation,
                speed: value,
            },
        };
    
        onChange(dataKey, updatedAnimationData);
    };
    
    const selectedValue = animationData?.imageAnimation?.animationValue;

    return (
        <Popover
            placement="left-start"
            className="vayu_blocks_toolspanel_items_popover"
            anchor={imagePopoverAnchor}
            onClose={() => setisImageVisible(false)}
            offset={35}
            resize
        >
            <VStack style={{ padding: '10px', width: '280px' }}>
                <Text>
                    <h4>{__('Image Animation', 'vayu-blocks')}</h4>
                    <p>{__('Select a image animation effect for your element.', 'vayu-blocks')}</p>
                </Text>

                <HStack spacing="2" wrap={true}>
                    {animationOptions.map(({ value, label, className }) => {
                        const isSelected = selectedValue === value || (!selectedValue && value === 'none');
                        const outerClass = `vayu-blocks-ihover-main-panel vayu-blocks-ihover-main-panel-p3 ${isSelected ? (!value || value === 'none' ? 'none-selected' : 'selected') : ''}`;
                        const innerClass = `vayu-blocks-panel-ihover ${className || `vayu_blocks_${value}_compoents_animation`}`;

                        const Element = value === 'clip-diagonal-expand' ? 'div' : Text;
                        return (
                            <Element
                                key={value}
                                className={outerClass}
                                onClick={() => handleImageAnimationClick(value)}
                                title={label}
                            >
                                <div className={innerClass} />
                            </Element>
                        );
                    })}
                </HStack>

                <br/>

                {selectedValue !== 'none' && (
                <>
                    <Text>
                        <ToggleGroupControl
                            className="togglegroupcontrol-vayu-blcoks-image-border-frame"
                            __next40pxDefaultSize
                            __nextHasNoMarginBottom
                            isBlock
                            value={ animationData?.imageAnimation?.hover || 'without-hvr' }
                            onChange={handleImagehoverClick}
                        >
                                
                            <ToggleGroupControlOption
                                label={__('Without Hover','vayu-blocks')}
                                value="without-hvr"
                            />
                            <ToggleGroupControlOption
                                label={__('Hover','vayu-blocks')}
                                value="with-hvr"
                            />
                            <ToggleGroupControlOption
                                label= {__('One Time','vayu-blocks')}
                                value="one-time" 
                            />
                                
                        </ToggleGroupControl>
                    </Text>

                    <Text>

                        <RangeControl
                            label={__('Speed', 'vayu-blocks')}
                            value={animationData?.imageAnimation?.speed}
                            onChange={(value) => handlespeed(value)}
                            step={0.1}
                            min={0}
                            max={10}
                            allowReset={true}
                        />

                    </Text>
                </>
                )}

            </VStack>
        </Popover>
    );
};

export const ImageAnimationPanel = ({
    animationData,
    isImageVisible,
    setImagePopoverAnchor,
    toggleImageVisible,
    dataKey, 
    onChange
}) => {

    const getAnimationClass = (imageselectedAnimation) => {
        switch (imageselectedAnimation) {
            case 'rotate-image':
                return 'vayu_blocks_rotate-image_compoents_animation';
            case 'clip-animation':
                return 'vayu_blocks_clip-animation_compoents_animation';
            case 'clip-diagonal-expand':
                return 'vayu_blocks_clip-diagonal-expand_compoents_animation';
            case 'clip-starburst':
                return 'vayu_blocks_clip-starburst_compoents_animation';
            case 'clip-diamond':
                return 'vayu_blocks_clip-diamond_compoents_animation';
            case 'clip-diagonal-slide':
                return 'vayu_blocks_clip-diagonal-slide_compoents_animation';
            case 'clip-hex-pulse':
                return 'vayu_blocks_clip-hex-pulse_compoents_animation';
            case 'clip-triangle-expand':
                return 'vayu_blocks_clip-triangle-expand_compoents_animation';
            case 'clip-circle-burst':
                return 'vayu_blocks_clip-circle-burst_compoents_animation';
            case 'clip-zigzag':
                return 'vayu_blocks_clip-zigzag_compoents_animation';
            case 'clip-diamond-expand':
                return 'vayu_blocks_clip-diamond-expand_compoents_animation';
            case 'shake':
                return 'vayu_blocks_shake_compoents_animation';
            default:
                return ''; // Return an empty string if no match
        }
    };

    const selectedImageEffect = animationOptions.find(opt => opt.value === animationData?.imageAnimation?.animationValue)?.label || '';

    const handleImageAnimationClick = (animation) => {
        const updatedAnimationData = {
            ...animationData,
            imageAnimation: {
                ...animationData.imageAnimation,
                animationValue: animation,
            },
        };
    
        onChange(dataKey, updatedAnimationData);
    };
    

    return (
        <ToolsPanelItem
            className="vayu_blocks_animation_toolspanel_item"
            hasValue={() => !!animationData?.imageAnimation?.animationValue}
            label={__('Image Animation', 'vayu-blocks')}
            onDeselect={() => handleImageAnimationClick('none')}
            isShownByDefault
        >
            <Button
                ref={setImagePopoverAnchor}
                onClick={toggleImageVisible}
                className={`block-editor-panel-animation-settings__dropdown ${isImageVisible ? 'is-open' : ''}`}
            >
                <HStack alignment="left">
                    {!animationData.imageAnimation.animationValue || animationData.imageAnimation.animationValue === 'none' ? (
                        <div className="vayu-blocks-panel-ihover vayu-blocks-none-button toolaspanel-size-none-button vayu_blocks_none" />
                    ) : (
                        <div style={{marginLeft:'3px'}} className={`vayu_blocks_hstack_animation_panel_image vayu_blocks_hstack_animation_panel_image_color ${getAnimationClass(animationData.imageAnimation.animationValue)}`} />
                    )}
                    <Text>
                        {__(
                            !animationData?.imageAnimation?.animationValue ||
                            animationData?.imageAnimation?.animationValue === 'none'
                                ? 'Image Animation'
                                : selectedImageEffect
                        )}
                    </Text>
                </HStack>
            </Button>
        </ToolsPanelItem>
    );
};

